import { type InstallationQuery } from "@packages/core";
import { useInfiniteQuery } from "@tanstack/react-query";

import { findInstallations } from "./functions";
import { QueryKey } from "./query";
import { NETWORK_SEMAPHORE } from "./semaphore";

function InstallationInfiniteQueryKey(
  ...parameters: Parameters<typeof useInstallationInfiniteQuery>
) {
  return QueryKey("InstallationList", ...parameters);
}

export function useInstallationInfiniteQuery(
  query: InstallationQuery,
  options?: Partial<{
    /** 処理を実行する場合に`true`を設定するフラグ */
    enabled: boolean;
  }>,
) {
  return useInfiniteQuery({
    queryKey: InstallationInfiniteQueryKey(query, options),
    async queryFn(context) {
      const release = await NETWORK_SEMAPHORE.acquire();
      try {
        return await findInstallations({ ...query, ...context.pageParam });
      } finally {
        release();
      }
    },

    getNextPageParam(lastPage) {
      return lastPage.nextPageToken ? { nextPageToken: lastPage.nextPageToken } : undefined;
    },
    initialPageParam: {} as { nextPageToken?: Record<string, any> },

    enabled: options?.enabled,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: /** 4時間 */ 14_400_000,
  });
}
